import { render, staticRenderFns } from "./PendingDocumentReview.vue?vue&type=template&id=2e45eb00"
import script from "./PendingDocumentReview.vue?vue&type=script&lang=js"
export * from "./PendingDocumentReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports